import { FundOfferBaseEntity } from '@genial/services';
import { ResponsesFundOfferCategoriesResponse } from '@genial/services/dist/models';
import { useSetRecoilState } from 'recoil';

import type { FundOperationType } from '../../../pages/NewApplication/Product/components/Funds/constants';
import {
  fundOffersByFilterParams,
  fundOffersBySearchTermParams,
  updateFundCategoriesOptionsFilterSelector,
  updateFundOffersAllSelector,
  updateFundOffersBySearchTermSelector,
  updateFundOffersOperationTypeSelector,
  updateFundRedemptionLiquidationAndQuotationDateSelector,
  updateFundRedemptionScheduleDateSelector,
  updateFundRedemptionsOffersAllSelector,
  updateFundRedemptionsOffersBySearchTermParamsSelector,
  updateFundRedemptionsOffersBySearchTermSelector,
} from '../selectors';
import {
  FundOfferByFilterParams,
  FundsOffersBySearchTerm,
  type FundRedemptionOfferNormalized,
  type FundRedemptionsOffersBySearchTerm,
} from '../types';

export const useFundsActions = () => {
  const setFundOffersByFilterParams = useSetRecoilState(fundOffersByFilterParams);
  const setFundAllOffers = useSetRecoilState(updateFundOffersAllSelector);
  const setFundBySearchTermOffers = useSetRecoilState(updateFundOffersBySearchTermSelector);
  const setFundOffersBySearchTermParams = useSetRecoilState(fundOffersBySearchTermParams);
  const setFundCategoriesOptionsFilter = useSetRecoilState(
    updateFundCategoriesOptionsFilterSelector
  );
  const setFundOffersOperationType = useSetRecoilState(updateFundOffersOperationTypeSelector);
  const setFundRedemptionsAllOffers = useSetRecoilState(updateFundRedemptionsOffersAllSelector);
  const setFundRedemptionsBySearchTermOffers = useSetRecoilState(
    updateFundRedemptionsOffersBySearchTermSelector
  );
  const setFundRedemptionsOffersBySearchTermParams = useSetRecoilState(
    updateFundRedemptionsOffersBySearchTermParamsSelector
  );
  const setFundRedemptionScheduleDate = useSetRecoilState(updateFundRedemptionScheduleDateSelector);

  const setFundRedemptionLiquidationAndQuotationDate = useSetRecoilState(
    updateFundRedemptionLiquidationAndQuotationDateSelector
  );

  const updateFundOffersByFilterParams = (value: Partial<FundOfferByFilterParams>) => {
    setFundOffersByFilterParams(value);
  };

  const updateFundOffersBySearchTermParams = (value: Partial<FundsOffersBySearchTerm>) => {
    setFundOffersBySearchTermParams(value);
  };

  const updateFundAllOffers = (value: FundOfferBaseEntity[]) => {
    setFundAllOffers(value);
  };

  const updateFundBySearchTermOffers = (value: FundOfferBaseEntity[]) => {
    setFundBySearchTermOffers(value);
  };

  const updateFundCategoriesOptionsFilter = (value: ResponsesFundOfferCategoriesResponse[]) => {
    setFundCategoriesOptionsFilter(value);
  };

  const updateFundOffersOperationType = (value: FundOperationType) => {
    setFundOffersOperationType(value);
  };

  const updateFundRedemptionsAllOffers = (value: FundRedemptionOfferNormalized[]) => {
    setFundRedemptionsAllOffers(value);
  };

  const updateFundRedemptionsBySearchTermOffers = (value: FundRedemptionOfferNormalized[]) => {
    setFundRedemptionsBySearchTermOffers(value);
  };

  const updateFundRedemptionsOffersBySearchTermParams = (
    value: Partial<FundRedemptionsOffersBySearchTerm>
  ) => {
    setFundRedemptionsOffersBySearchTermParams(value);
  };

  const updateFundRedemptionScheduleDate = (scheduleDate: Date) => {
    setFundRedemptionScheduleDate(scheduleDate);
  };

  const updateFundRedemptionLiquidationAndQuotationDate = (dates: {
    liquidationDate: Date;
    liquidationDateFormatted: string;
    quotationDate: Date;
    quotationDateFormatted: string;
  }) => {
    setFundRedemptionLiquidationAndQuotationDate(dates);
  };

  return {
    updateFundRedemptionLiquidationAndQuotationDate,
    updateFundRedemptionScheduleDate,
    updateFundOffersByFilterParams,
    updateFundOffersBySearchTermParams,
    updateFundAllOffers,
    updateFundBySearchTermOffers,
    updateFundCategoriesOptionsFilter,
    updateFundOffersOperationType,
    updateFundRedemptionsAllOffers,
    updateFundRedemptionsBySearchTermOffers,
    updateFundRedemptionsOffersBySearchTermParams,
  };
};
